let posX;
let posY;
let isClick;
const canvas = document.getElementById('canvas');

document.addEventListener('mousedown', function(e) {
    setClick(e, true);
});

document.addEventListener('mouseup', function(e) {
    setClick(e, false);
});

canvas.onmousemove = function(e) {
    posX = e.offsetX;
    posY = e.offsetY;
}

function setClick(event, status) {
    isClick = status;
}

export default {
    get getPosX() {
        return posX;
    },
    get getPosY() {
        return posY;
    },
    get isClick() {
        return isClick;
    },
};
